<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                <div class="d-flex justify-content-between align-items-center flex-wrap px-3">
                <h6 class="text-white text-capitalize">(26년) 선생님 반 편성</h6>
                <div class="d-flex align-items-center flex-wrap">
                  <select v-model="filters.department" @change="onDeptChange" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;" >
                    <option value="">전체</option>
                    <option v-for="department in departments" :key="department.id" :value="department.id">
                      {{ department.name }}
                    </option>
                  </select>
                  <input v-model="filters.name" type="text" class="form-control me-2 searchInput w-16" placeholder="이름 검색" />
                  <input v-model="filters.phone" type="text" class="form-control me-2 searchInput w-16" placeholder="연락처 검색" />
                  <button class="btn btn-light text-success ms-2" @click="fetchList(1)">검색</button>
                  <button v-if="false" class="btn btn-light text-success mt-2 mt-sm-0" @click="openCreate">등록</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table mb-0">
                <thead>
                  <tr class="text-center">
                    <th>번호</th>
                    <th>부서</th>
                    <th>이름</th>
                    <th>반</th>
                    <th>연락처</th>
                    <th>상태</th>
                    <th>등록일</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="rows.length === 0">
                    <td colspan="8" class="text-center">자료가 없습니다</td>
                  </tr>
                  <tr v-for="(r, idx) in rows" :key="r.id" class="text-center">
                    <td>{{ (idx + 1) + ((currentPage - 1) * pageSize) }}</td>
                    <td>{{ r.class_name }}</td>
                    <td class="name" style="cursor:pointer; color:#0b62ff; font-weight:600;" @click="openEdit(r)">{{ r.name }}</td>
                    <td>{{ r.gradename || r.grade }}</td>
                    <td>{{ r.phone }}</td>
                    <td>{{ r.useyn_name }}</td>
                    <td>{{ r.createdt }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-center mt-4">
              <nav aria-label="Page navigation" v-if="totalPages > 0">
                <ul class="pagination">
                  <li class="page-item" :class="{ disabled: currentPage === 1 }">
                    <a class="page-link" href="#" @click.prevent="currentPage > 1 && fetchList(currentPage - 1)">&laquo;</a>
                  </li>
                  <li v-for="page in displayedPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
                    <a class="page-link" href="#" @click.prevent="fetchList(page)">{{ page }}</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                    <a class="page-link" href="#" @click.prevent="currentPage < totalPages && fetchList(currentPage + 1)">&raquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="guide-box mt-3">
              <p class="mb-2">📢 <strong>선생님 반 편성 안내</strong></p>
              <p class="mb-1"><strong>선생님 확인 절차 안내</strong></p>
              <p class="mb-1" style="color:red;">선생님을 "전체" 조회로 기존 등록 여부를 먼저 확인하시기 바랍니다.</p>
              <p class="mb-1" style="color:red;">조회 조건을 <strong>전체</strong>로 설정한 후 이름 검색을 통해 타 부서에서 봉사 중인지 여부를 확인합니다.</p>
              <p class="mb-1">기존에 등록된 정보가 있을 경우, 필요 시 부서를 수정하여 사용합니다.</p>
              
              <p class="mb-1"><strong>삭제 처리 안내</strong></p>
              <p class="mb-0">선생님 정보는 삭제 처리하지 않으며, 더 이상 활동하지 않는 경우 상태를 “비활성”으로 변경하여 관리해 주시기 바랍니다.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="popup-overlay" @click.self="closeModal">
      <div class="popup-content">
        <h6 class="mb-3">{{ isCreate ? '등록' : '수정' }}</h6>
        <div class="row">
          <div class="col-md-6 mb-2">
            <label class="form-label">이름</label>
            <input class="form-control" v-model="form.name" :readonly="true" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">연락처</label>
            <input class="form-control" v-model="form.phone" :readonly="true" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">부서</label>
            <select class="form-select" v-model="form.classid" @change="onModalDeptChange">
              <option v-for="d in departments" :key="d.id" :value="d.id">{{ d.name }}</option>
            </select>
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">반(grade)</label>
            <select class="form-select" v-model="form.grade">
              <option v-for="g in modalGrades" :key="g.grade" :value="g.grade">{{ g.gradename }}</option>
            </select>
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">상태</label>
            <select class="form-select" v-model="form.useyn">
              <option value="Y">활성</option>
              <option value="N">비활성</option>
            </select>
          </div>
        </div>
        <div class="text-end">
          <button class="btn btn-secondary me-2" @click="closeModal">취소</button>
          <button class="btn btn-success" @click="save">저장</button>
        </div>
      </div>
    </div>
  </div>
  </template>

<script>
import apiservice from "@/services/apiservice";

export default {
  name: "TeacherTemp",
  data() {
    return {
      rows: [],
      departments: [],
      modalGrades: [],
      filters: { department: '', name: '', phone: '' },
      pageSize: 20,
      currentPage: 1,
      totalPages: 1,
      showModal: false,
      isCreate: false,
      form: { id: null, classid: '', name: '', phone: '', grade: '', useyn: 'Y' }
    };
  },
  computed: {
    // isSuperUser() { return this.$store.state.userData?.superuser === '1'; },
    displayedPages() {
      const pages = [];
      const max = 5;
      if (this.totalPages <= max) {
        for (let i = 1; i <= this.totalPages; i++) pages.push(i);
      } else {
        let start = Math.max(1, this.currentPage - Math.floor(max/2));
        let end = start + max - 1;
        if (end > this.totalPages) { end = this.totalPages; start = Math.max(1, end - max + 1); }
        for (let i = start; i <= end; i++) pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    async fetchDepartments() {
      const res = await apiservice.getdeptlist();
      this.departments = res.data.data.map(d => ({ id: d.code, name: d.codename }));
    },
    async onDeptChange() {
      // 부서 변경 시 리스트만 재조회 (반 필터 제거)
      await this.fetchList(1);
    },
    async onModalDeptChange() {
      if (!this.form.classid) { this.modalGrades = []; return; }
      const res = await apiservice.get_temp_classlist({ classid: this.form.classid });
      this.modalGrades = res.data.data || [];
      if (!this.modalGrades.find(g => g.grade === this.form.grade)) {
        this.form.grade = '';
      }
    },
    async fetchList(page = 1) {
      const params = { page, limit: this.pageSize, department: this.filters.department, name: this.filters.name, phone: this.filters.phone };
      const res = await apiservice.teachertemp_list({ params });
      this.rows = res.data.data || [];
      this.currentPage = parseInt(res.data.currentPage || 1);
      this.totalPages = parseInt(res.data.totalPages || 1);
    },
    openEdit(r) {
      this.isCreate = false;
      this.form = { id: r.id, classid: r.classid, name: r.name, phone: r.phone, grade: r.grade, useyn: r.useyn };
      this.showModal = true;
      this.onModalDeptChange();
    },
    openCreate() {
      this.isCreate = true;
      this.form = { id: null, classid: this.filters.department, name: '', phone: '', grade: '', useyn: 'Y' };
      this.showModal = true;
      this.onModalDeptChange();
    },
    closeModal() { this.showModal = false; },
    async save() {
      try {
        if (this.isCreate) {
          await apiservice.teachertemp_create({ ...this.form });
        } else {
          await apiservice.teachertemp_update(this.form);
        }
        this.showModal = false;
        this.fetchList(this.currentPage);
      } catch (e) { alert('저장 중 오류'); }
    },
    async remove(r) {
      if (!confirm('삭제하시겠습니까?')) return;
      try { await apiservice.teachertemp_delete({ id: r.id }); this.fetchList(this.currentPage); }
      catch (e) { alert('삭제 중 오류'); }
    }
  },
  async mounted() {
    await this.fetchDepartments();
    const user = this.$store.state.userData;
    if (user && user.superuser !== '1') {
      this.filters.department = user.classid;
      await this.onDeptChange();
    }
  }
};
</script>

<style scoped>
.searchInput { text-align: center; background-color: white !important; margin-bottom: 0; }
.w-16 { width: 11.5% !important; min-width: 140px; }
.popup-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.4); display:flex; align-items:center; justify-content:center; z-index: 1050; }
.popup-content { background:#fff; border-radius:8px; padding:16px; width:600px; max-width:95vw; border: 1px solid #dee2e6; }
/* 컴포넌트 테두리 명확화 */
.form-control, .form-select {
  border: 1px solid #ced4da !important;
  box-shadow: none !important;
}
/* 버튼 하단 여백 제거로 수평 정렬 보장 */
.btn { margin-bottom: 0 !important; }
/* 안내 박스 */
.guide-box {
  background: #f8f9fa;
  border: 1px solid #e0e6ed;
  border-radius: 8px;
  padding: 12px 16px;
  color: #344767;
  font-size: 0.925rem;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .d-flex { flex-direction: column; align-items: stretch; }
  .form-select, .form-control { width: 100% !important; margin-bottom: 10px; }
  .searchInput { text-align: left; }
}
</style>


